import withAEM from '../../hoc/withAEM'
import RuleBuilder from '../shared/RuleBuilder'

export default withAEM(RuleBuilder, {
  compName: 'RuleBuilder',
  showErrorBanner: true
})
